import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { WordTreeChart } from "../../../../Constant";
import { WORD_TREE_CHART_DATA, WORD_TREE_CHART_OPTION } from "../../../../Data/Charts/GoogleChart";
import { Chart } from "react-google-charts";

const WordTree = () => {
  return (
    <Col sm="12" xl="6" className="box-col-12">
      <Card>
        <CommonCardHeader title={WordTreeChart} />
        <CardBody className="chart-block">
          <div className="chart-overflow" id="wordtree_basic">
            <Chart chartType="WordTree" width="100%" height="400px" data={WORD_TREE_CHART_DATA} options={WORD_TREE_CHART_OPTION} />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default WordTree;
